import i18n from "~/i18n";

export const verboseDescriptiveStatus = (descriptiveStatus) => {
  switch (descriptiveStatus) {
    case "paid":
      return i18n.t("Paid");
    case "canceled":
      return i18n.t("Canceled");
    case "partially_paid":
      return i18n.t("Partially Paid");
    case "sent":
      return i18n.t("Sent");
    case "unsent":
      return i18n.t("Not Sent");
  }
};

export const INVOICE_STATUS_UNSENT = "unsent";
export const INVOICE_STATUS_SENT = "sent";
export const INVOICE_STATUS_PARTIALLY_PAID = "partially_paid";
export const INVOICE_STATUS_PAID = "paid";
export const INVOICE_STATUS_CANCELED = "canceled";
